<template>
  <div>
    <div class="font-bold p-2">Text</div>
    <div class="flex gap-2 p-2 text-gray-300">
      <SMButton v-tippy="'Duplicate'" icon="copy" :on-click="duplicate" />
      <SMButton v-tippy="'Delete'" icon="delete" :on-click="remove" />
    </div>
    <div class="md-subheading px-2 my-2 bg-gray-200">Styles</div>
    <ul class="space-y-2 p-2">
      <li>
        <SMInput v-model="textValue" v-tippy="'Text'" icon="text" placeholder="Text" @change="onTextChange" />
      </li>
      <li>
        <SMNumberInput
          v-model="fontSize"
          v-tippy="'Font Size'"
          :min="20"
          :max="200"
          icon="font-size"
          @change="onFontSizeValueChange"
        />
      </li>
      <li>
        <SMColorPicker v-model="textColor" v-tippy="'Label Color'" icon="text-color" class="grow" />
      </li>
    </ul>
  </div>
</template>
<script lang="ts" setup>
import SMButton from '@/components/ui/SMButton.vue';
import SMColorPicker from '@/components/ui/SMColorPicker.vue';
import SMInput from '@/components/ui/SMInput.vue';
import SMNumberInput from '@/components/ui/SMNumberInput.vue';
import eventbus from 'tiny-emitter/instance';
import tinycolor from 'tinycolor2';

import { Text } from '@/core/models/text';
import { PropType, computed, ref, shallowRef, watchEffect } from 'vue';

const blackRgba = tinycolor('black').toRgb();
const props = defineProps({
  units: {
    type: Array as PropType<Text[]>,
    required: true,
  },
});

const unit = shallowRef(props.units[0]);
const textValue = ref(unit.value.attributes.label.value);
const color = ref({ rgba: unit.value.attributes.fill ? tinycolor(unit.value.attributes.fill).toRgb() : blackRgba });
const fontSize = ref(unit.value.attributes.size);

watchEffect(() => {
  unit.value = props.units[0];
  textValue.value = unit.value.attributes.label.value;
  color.value = { rgba: unit.value.attributes.fill ? tinycolor(unit.value.attributes.fill).toRgb() : blackRgba };
  fontSize.value = unit.value.attributes.size;
});

const textColor = computed({
  get() {
    return tinycolor(color.value.rgba).toRgbString();
  },
  set(value) {
    updateTextColor({ rgba: value as unknown as tinycolor.ColorFormats.RGBA });
  },
});

const updateTextColor = ({ rgba }: { rgba: tinycolor.ColorFormats.RGBA }) => {
  unit.value.changeFontColor(tinycolor(rgba).toRgbString());
  color.value.rgba = rgba;
};
const onFontSizeValueChange = (value: number) => {
  unit.value.changeFontSize(value);
  eventbus.emit('seatmap:updateSelectionBox');
};
const onTextChange = (value: string) => {
  unit.value.changeText(value.trim());
  eventbus.emit('seatmap:updateSelectionBox');
};
const duplicate = () => {
  eventbus.emit('selection:clone');
};
const remove = () => {
  eventbus.emit('selection:remove');
};
</script>
<style lang="scss" scoped>
.md-input-container {
  min-height: auto !important;
  margin: 0 !important;
  padding-top: 0;

  label {
    top: 10px;
  }
}
.md-input-focused {
  label {
    display: none;
  }
}
</style>
